import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL: z.union([z.url(), z.literal('same-origin')]),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_VAPID_PUBLIC_KEY: z.string().optional(),
  VITE_CHAT_TENANTS: z.string().optional(),
});

const parsed = schema.safeParse(import.meta.env);

/** Public, non-secret configuration baked into the static build. */
export const env = parsed.success
  ? { supabaseUrl: parsed.data.VITE_SUPABASE_URL === 'same-origin' ? globalThis.location.origin : parsed.data.VITE_SUPABASE_URL, supabaseAnonKey: parsed.data.VITE_SUPABASE_ANON_KEY, vapidPublicKey: parsed.data.VITE_VAPID_PUBLIC_KEY || null, chatTenants: (parsed.data.VITE_CHAT_TENANTS ?? '').split(',').map((s) => s.trim()).filter(Boolean), ok: true as const }
  : { supabaseUrl: '', supabaseAnonKey: '', vapidPublicKey: null, chatTenants: [] as string[], ok: false as const, error: parsed.error.issues.map((i) => i.path.join('.')).join(', ') };
